import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Stars from "@/components/Stars";
import { formatIDR } from "@/lib/format";
import { useLang } from "@/context/LanguageContext";

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { t } = useLang();
  return (
    <div className="card-lift bg-white rounded-3xl border border-zinc-100 overflow-hidden flex flex-col" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block">
        <div className="aspect-square product-image-bg overflow-hidden">
          <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" />
        </div>
      </Link>
      <div className="p-5 flex-1 flex flex-col">
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400">{product.category}</div>
        <Link to={`/product/${product.id}`} className="mt-1">
          <div className="font-semibold text-[15px] text-zinc-900 leading-snug line-clamp-2 hover:text-brand transition-colors">{product.name}</div>
        </Link>
        {product.rating_count > 0 && (
          <div className="mt-2 flex items-center gap-1.5">
            <Stars value={product.rating_avg} size={12} />
            <span className="text-xs text-zinc-500">({product.rating_count})</span>
          </div>
        )}
        <div className="mt-auto pt-4 flex items-center justify-between">
          <div className="font-display font-bold text-lg text-zinc-900">{formatIDR(product.price)}</div>
          <Button
            data-testid={`add-to-cart-${product.id}`}
            onClick={(e) => { e.preventDefault(); addItem(product); }}
            className="rounded-full bg-zinc-900 hover:bg-brand text-white h-9 px-4 text-sm font-semibold"
          >
            <Plus className="w-4 h-4 mr-1" /> {t("product.add")}
          </Button>
        </div>
      </div>
    </div>
  );
}
